import React from 'react';
import { Button, CountdownFormat } from '@talbenmoshe/trip-os-design-system';
import { SignInActivity, useSignIn } from '@talbenmoshe/trip-os-react-model';
import { useMessages } from '../i18n/messagesContext.js';

/**
 * The code step's main button. "Sign in" while the code can still be used (D1–D6); once it has expired or is
 * locked, "Send a new code" (D7), disabled with the countdown until a new code may be requested (D8).
 * It is always the form's submit button, so the step's submit handler decides what it does. The button that is
 * loading is never natively disabled, so it keeps keyboard focus.
 */
export function CodeStepPrimaryButton() {
  const messages = useMessages();
  const signIn = useSignIn();
  const isChecking = signIn.activity === SignInActivity.CHECKING_CODE;
  const isResending = signIn.activity === SignInActivity.RESENDING_CODE;
  let label = messages.SIGN_IN_SUBMIT_CODE();
  let loadingLabel = messages.SIGN_IN_CHECKING_CODE();
  let isLoading = isChecking;
  let isDisabled = signIn.isBusy && !isChecking;

  if (!signIn.isCodeUsable) {
    label = messages.SIGN_IN_SEND_NEW_CODE_IN(CountdownFormat.format(signIn.secondsUntilResend));
    loadingLabel = messages.SIGN_IN_RESENDING_CODE();
    isLoading = isResending;
    isDisabled = !signIn.canRequestNewCode && !isResending;
  }

  if (!signIn.isCodeUsable && signIn.canRequestNewCode) {
    label = messages.SIGN_IN_SEND_NEW_CODE();
  }

  return <Button label={label} type="submit" fullWidth loading={isLoading} loadingLabel={loadingLabel} disabled={isDisabled} />;
}
